import { useState as m, useEffect as a } from "react";
import u from "../data/breakpoints.js";
const h = () => {
  const [i, e] = m("desktop"), d = Object.entries(u).map(([t, c]) => ({ name: t, value: c })), n = () => {
    if (window != null && window.matchMedia) {
      e(d.reduceRight((o, { name: r, value: s }) => window.matchMedia(`(max-width: ${s}px)`).matches ? r : o, i));
      return;
    }
    const t = document != null && document.documentElement ? document.documentElement.clientWidth : window == null ? void 0 : window.innerWidth;
    if (t) {
      e(d.reduceRight((o, { name: r, value: s }) => +s >= t ? r : o, i));
      return;
    }
    if (window.navigator.userAgent === "forma-mobile") {
      e("phone");
      return;
    }
    e("desktop");
  };
  return a(() => (n(), window.addEventListener("resize", n), () => window.removeEventListener("resize", n)), []), i;
};
export {
  h as default
};
